module.exports = __webpack_public_path__ + "img/ghost-avatar-white.f9e7a952.png";